export default {
  // homepage,
  '/': 'homepage',

  // registration
  '/signup(/:type)': 'registrationSignup',
  '/login': 'registrationLogin',
  '/forgot': 'registrationLogin',

  // inbox
  '/inbox': 'inboxInbox',
  '/inbox/archive': 'inboxInbox',
  '/inbox/:id': 'inboxThread',

  // cart
  '/cart/:id/:hash': 'cart',

  // account
  '/agenda': 'accountAgenda',
  '/agenda/new': 'accountAgenda',
  '/agenda/old': 'accountAgenda',
  '/agenda/:id': 'accountAgenda',
  '/agenda/:id/dispute': 'accountAgenda',
  '/orders': 'accountOrders',
  '/payouts': 'accountPayouts',
  '/payouts/:id': 'accountPayoutDetails',
  '/orders/cancel': 'accountDispute',
  '/refill/:id': 'accountRefill',
  '/refill/:id/payment': 'accountRefill',
  '/teacher_stats': 'accountStats',

  // book
  '/booking/:id/start': 'bookingInitial',
  '/booking/:id/payment': 'bookingInitial',

  // booking
  '/booking/:id': 'bookingDetails',
  '/booking/:id/price': 'bookingPrice',

  // invite
  '/invite': 'pagesInvite',

  // student invite
  '/s-invite': 'pagesInvite',

  // gift card
  '/cheque-cadeaux-cours-particuliers-musique-langue': 'pagesGift',
  '/gift-card-music-languages-lessons': 'pagesGift',
  '/tarjeta-regalo-clases-particulares-musica-lenguas': 'pagesGift',
  '/cadeaukaart-prive-lessen-muziek-taal': 'pagesGift',
  '/geschenkkarte-musik-sprachen-privatunterricht': 'pagesGift',
  '/بطاقة-هدايا-دروس-موسيقى-لغات': 'pagesGift',

  '/gift-card/:id/:hash': 'pagesGift',
  '/gift-card': 'pagesGift',
  '/christmas-gift-card': 'pagesGift',
  '/cheque-cadeau-noel': 'pagesGift',
  '/weihnachts-geschenk-karte': 'pagesGift',
  '/tarjeta-regalo-navidad': 'pagesGift',
  '/kerst-kado-kaart': 'pagesGift',
  '/بطاقة-هدايا-عيد-الميلاد': 'pagesGift',

  // tutor promo
  '/comment-donner-cours-particuliers': 'campaignsRecruitment',
  '/how-to-become-a-tutor-teacher': 'campaignsRecruitment',
  '/hoe-word-ik-leraar-bijles-docent': 'campaignsRecruitment',
  '/como-convertirse-en-profesor-tutor': 'campaignsRecruitment',
  '/wie-werde-ich-Nachhilfe-Lehrer': 'campaignsRecruitment',
  '/كيف-تصبح-مدرّسا': 'campaignsRecruitment',

  // request
  '/looking-for-a-teacher': 'pagesRequest',
  '/je-cherche-un-professeur-particulier': 'pagesRequest',
  '/zoek-je-een-prive-leraar-bijles-docent': 'pagesRequest',
  '/suche-nach-einem-lehrer': 'pagesRequest',
  '/solicitar-al-profe': 'pagesRequest',
  '/ابحث-عن-مدرس': 'pagesRequest',

  // reviews
  '/apprentus-reviews': 'reviews',
  '/avis-apprentus': 'reviews',
  '/apprentus-calificaciones': 'reviews',
  '/apprentus-bewertungen': 'reviews',
  '/apprentus-beoordelingen': 'reviews',
  '/تقييمات-apprentus': 'reviews',

  // users
  '/users/hydrate': 'pagesHydrate',

  // confirm email popup
  '/popups/confirm': 'popupsConfirm',

  // phone popup
  '/popups/phone': 'popupsPhone',

  // message popup
  '/popups/message/:userId': 'popupsMessage',

  // profile
  '/profile/account': 'profileAccount',
  '/profile/account/notifications': 'notifications',
  '/profile/account/close': 'closeAccount',
  '/profile/account/payments': 'payments',
  '/profile/account/account': 'account',
  '/profile/account/invoices': 'invoices',
  '/profile/edit': 'profileProfile',
  '/profile/verifications': 'profileVerifications',
  '/profile/dashboard(/:user_id)': 'profileDashboard',

  // review course
  '/profiles/:id/review': 'reviewClass',

  // public profile
  '/profiles/:id': 'profilePublic',
  '/profile': 'profilePublic',
  '/in/:url': 'profilePublic',

  // courses
  '/courses': 'courseList',
  '/courses/new': 'courseEdit',
  '/courses/:id/edit': 'courseEdit',
  '/courses/:id/translate': 'courseTranslate',
  '/courses/:id/translate/:language_id': 'courseTranslate',
  '/courses/:id/suspend': 'courseSuspend',
  '/courses/:id/boost': 'courseBoost',
  '/courses/:id/boost/redeem': 'courseRedeem',

  // course
  '/courses/:id': 'courseShow',

  // faqs
  '/aide(/:questionTypeSlug)(/:questionTypeSlug/:slug)': 'faqs',
  '/help(/:questionTypeSlug)(/:questionTypeSlug/:slug)': 'faqs',
  '/hulp(/:questionTypeSlug)(/:questionTypeSlug/:slug)': 'faqs',
  '/ayuda(/:questionTypeSlug)(/:questionTypeSlug/:slug)': 'faqs',
  '/hilfe(/:questionTypeSlug)(/:questionTypeSlug/:slug)': 'faqs',
  '/مساعدة(/:questionTypeSlug)(/:questionTypeSlug/:slug)': 'faqs',

  // how apprentus works
  '/t/:locationString/:tutoSlug': 'how',
  '/م/:locationString/:tutoSlug': 'how',

  // search
  '/favourites': 'search',
  '/s/:location_puzzle(/:query)(/:bounds)(/:zoom)(/:per_page)(/:page)(/:filter)': 'search',
  '/:slug(/:extra)(/:another_extra)': 'search',

  // course wildcard/slug
  '/:lesson_string/:city/:main_category/:sub_category/:title': 'courseShow'
}
